// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/thunderstorm-hazards.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/thunderstorm-hazards/thunderstorm-hail.js';
import g1 from '../lessons/meteorology/thunderstorm-hazards/thunderstorm-hazard-list.js';
import g2 from '../lessons/meteorology/thunderstorm-hazards/thunderstorm-hazards.js';

mount([g0, g1, g2]);
